const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
export function isRequired(value) {
    return !!value ? false : 'Required';
}
export function isEmail(value) {
    return EMAIL_REGEX.test(value) ? false : 'Invalid e-mail';
}
//# sourceMappingURL=Spreadsheet.validators.js.map